import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import './Steps.scss';

export default function Steps() {
  const { t } = useI18n();
  const items = t('videoGeneration.sora.steps.items');
  return (
    <section className="sora2-steps">
      <div className="sora2-steps__inner">
        <h2>{t('videoGeneration.sora.steps.title')}</h2>
        <p className="sora2-steps__sub">{t('videoGeneration.sora.steps.sub')}</p>

        <div className="sora2-steps__grid">
          {items.map((it, idx) => (
            <React.Fragment key={it.num}>
              <div className="sora2-step">
                <div className="sora2-step__badge">{it.num}</div>
                <h3>{it.title}</h3>
                <p>{it.text}</p>
              </div>
              {idx < items.length - 1 && <div className="sora2-steps__arrow" />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}